import Alpine from 'alpinejs';

interface Band {
  name: string;
  genre?: string;
  hometown?: string;
  homecountry?: string;
}

interface Concert {
  title?: string;
  dateStart: string;
  dateEnd?: string;
  location?: string;
  link?: string;
  bands?: Band[];
}

const apiUrl = process.env.CONCERTS_API_URL ?? '';
const fetchConcerts = async (): Promise<Concert[]> => {
  try {
    const response = await fetch(apiUrl);
    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }
    return await response.json();
  } catch {
    return [
      {
        title: 'Fehler 500: Crisis on Infinite Earths',
        dateStart: '3048-11-13',
        link: 'https://de.wikipedia.org/wiki/Crisis_on_Infinite_Earths',
        bands: [
          {
            name: 'Die aktuellen Daten konnten leider nicht abgerufen werden, bitte versuche es später noch einmal.',
          },
        ],
      },
    ];
  }
};

window.Alpine = Alpine;
Alpine.data('concerts', () => ({
  concerts: [] as Concert[],
  dateBeforeNow(date: string): boolean {
    return Date.parse(date) < Date.now();
  },
  getDateDay(date: string): number {
    const jsDate = new Date(date);
    return jsDate.getDate();
  },
  getDateMonth(date: string): string {
    const jsDate = new Date(date);
    return jsDate.toLocaleDateString('de-DE', { month: 'long' });
  },
  getDateYear(date: string): number {
    const jsDate = new Date(date);
    return jsDate.getFullYear();
  },
  async getData() {
    this.concerts = await fetchConcerts();
  },
}));
Alpine.start();

const bodyEl: HTMLElement = document.body;
bodyEl.classList.remove('no-js');
window.addEventListener('load', () => {
  setTimeout(() => {
    bodyEl.classList.add('initialized');
  }, 500);
});

const toggleConcerts = (trigger: HTMLElement) => {
  const hiddenConcerts = document.querySelectorAll('.concert--hidden');
  hiddenConcerts.forEach((element) => {
    element.classList.remove('concert--hidden');
  });
  trigger.remove();
};
window.toggleConcerts = toggleConcerts;
